<template>
  <div
    :class="`content-carousel ${carouselClasses}`">
    <template v-if="loading">
      <ACarousel
        :options="carouselOptions"
        place-arrows-outside
        place-pagination-outside
      >
        <ACarouselSlide
          v-for="n in 3"
          :key="n"
          :index="n"
          :ssr-number="ssrSlideNumber"
          :ssr-margin="ssrSlideMargin"
          class="content-carousel-slide"
        >
          <slot :item="{}" />
        </ACarouselSlide>
        <div
          slot="pagination"
          class="swiper-pagination"
        />
      </ACarousel>
    </template>
    <template v-else-if="items.length > 0">
      <ACarousel
        :options="carouselOptions"
        place-arrows-outside
        place-pagination-outside
      >
        <ACarouselSlide
          v-for="(item, index) in items"
          :key="item.id"
          :index="index"
          :ssr-number="ssrSlideNumber"
          :ssr-margin="ssrSlideMargin"
          :data-cy="`content-carousel-slide-${index}`"
          class="content-carousel-slide"
        >
          <slot :item="item" />
        </ACarouselSlide>
      </ACarousel>
    </template>
  </div>
</template>

<script>
export default {
  name: 'carousel',
  props: {
    items: {
      type: Array,
      required: true
    },
    carouselClasses: {
      type: String,
      required: false,
      default: ''
    },
    loading: {
      type: Boolean,
      required: true
    },
    numItems: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    ssrSlideNumber() {
      let num = 1
      if (this.carouselOptions) {
        if (this.carouselOptions.slidesPerView) {
          num = this.carouselOptions.slidesPerView
        }
      }
      return num
    },
    ssrSlideMargin() {
      let num = 0
      if (this.carouselOptions) {
        if (this.carouselOptions.spaceBetween) {
          num = this.carouselOptions.spaceBetween
        }
      }
      return num
    },
    carouselOptions() {
      return {
        slidesPerView: (this.numItems !== null) ? Number(this.numItems) : 3,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
          480: {
            slidesPerView: 1
          },
          640: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~@scss/custom.scss';

  .content-carousel {
    .a-carousel {
      width: 100%;
      min-width: 100%;
      .content-carousel-slide {
        display: flex;
        height: 100%;
      }
    }

    &.products-carousel {
      .a-carousel .content-carousel-slide {
        height: unset;
      }
    }
  }
</style>
